import { createFileRoute } from '@tanstack/react-router';

import { AdminAdminsPage } from '@/components/admin/admins-page';
import { adminHead } from '@/lib/seo';
import { adminListAdminsFn } from '@/server/functions/admins';

export const Route = createFileRoute('/_admin/admin/admins')({
    component: AdminsRoute,
    head: () => adminHead('צוות', '/admin/admins'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListAdminsFn(),
});

function AdminsRoute() {
    const data = Route.useLoaderData();
    return <AdminAdminsPage initial={data} />;
}
